import React from 'react'
//import PropTypes from 'prop-types'

const Controls = (props) => {
	return (
		<div style={{ color: '#f00', position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', zIndex: '2'}}>controls</div>
	)
}

Controls.propTypes = {}

export default Controls


// WEBPACK FOOTER //
// ./src/mobile/components/video-player/controls.js